import * as React from 'react';
import { Button, Paper, Table, TableBody,
	TableCell, TableContainer, TableHead,
	TablePagination, TableRow } from "@material-ui/core";

import { getAllInvest } from '../../repository/db.js';
import { useNavigate } from 'react-router-dom';
import { withAuthenticationRequired } from '@auth0/auth0-react';

withAuthenticationRequired

const columns = [
  { id: 'date', label: 'Date', minWidth: 100 },
  { id: 'currencyPair', label: 'Currency Pair', minWidth: 100 },
  { id: 'entryPrice', label: 'Entry Price', minWidth: 50 },
  { id: 'action', label: 'Action', minWidth: 50 },
  { id: 'stopLoss', label: 'Stop Loss', minWidth: 50 },
  { id: 'takeProfit', label: 'Take Profit', minWidth: 50 },
  { id: 'type', label: 'Type', minWidth: 50 },
  { id: 'result', label: 'Result', minWidth: 50 },
];


function StickyHeadTable(props) {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [invests, setInvests] = React.useState([]);
  const navigate = useNavigate()

  React.useEffect(() => {
    async function fetchData () {
      const invest = await getAllInvest()
      setInvests(invest?.data)
    }

    fetchData()
  }, [])

 

  const detailView = (ref, investData) => {
      navigate(`/invest/${ref}`, { state:  { investData, ref }})
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  return (
    <Paper sx={{ width: '100%', overflow: 'hidden' }}>
      <TableContainer sx={{ maxHeight: 440 }}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{ minWidth: column.minWidth }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {invests && invests
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row) => {
                return (
                  <TableRow hover role="checkbox" tabIndex={-1} key={row.code}>
                    {columns.map((column) => {
                      const value = row.data[column.id];
                      return (
                        <TableCell key={`${column.id}-${row.ref?.value?.id}`}>
                          {value && column.format && typeof value === 'number'
                            ? column.format(value)
                            : value}
                        </TableCell>
                      );
                    })}
                    <TableCell key={`Button-${row.ref?.value?.id}`}>
                      <Button variant="contained" onClick={() => detailView(row.ref?.value?.id, row.data) }>DETAILS</Button>
                    </TableCell>
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[5, 10, 25, 100]}
        component="div" 
        count={invests?.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Paper>
  );
}

export default withAuthenticationRequired(StickyHeadTable, {
});